import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=e0ec40d6&scoped=true&"
import script from "./UserCard.vue?vue&type=script&lang=ts&"
export * from "./UserCard.vue?vue&type=script&lang=ts&"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=e0ec40d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ec40d6",
  null
  
)

export default component.exports